<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-container">
      <h2>Confirm User Creation</h2>
      <p class="modal-desc">
        Review the details below before proceeding.
      </p>

      <div class="user-details">
        <p><strong>Full Name:</strong> {{ user.full_name }}</p>
        <p><strong>Email:</strong> {{ user.email }}</p>
        <p><strong>Role:</strong> {{ roleLabel }}</p>
        <p><strong>Password:</strong> {{ user.password ? '••••••••' : '' }}</p>

        <div class="permissions">
          <p><strong>Permissions (fixed for this role):</strong></p>
          <ul>
            <li v-for="(label, index) in permissionLabels" :key="index">
              {{ label }}
            </li>
          </ul>
        </div>
      </div>

      <div class="button-group">
        <button class="btn cancel" @click="$emit('cancel')">Cancel</button>
        <button class="btn confirm" @click="$emit('confirm')">Confirm</button>
      </div>
    </div>
  </div>
</template>

<script>
const ROLE_LABELS = {
  finance: 'Finance Admin',
  support: 'Support Admin',
  super_admin: 'Super Admin'
}

export default {
  name: "ConfirmCreateUser",
  props: {
    visible: Boolean,
    user: Object,
    permissionLabels: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    roleLabel() {
      return ROLE_LABELS[this.user?.role] || this.user?.role || ''
    }
  }
};
</script>

<style scoped>
/* ============ OVERLAY ============ */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 1rem;
}

/* ============ MODAL BOX ============ */
.modal-container {
  background: var(--background-color2);
  color: var(--text-color1);
  border-radius: 10px;
  width: 100%;
  max-width: 420px;
  padding: 1.5rem;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
  animation: fadeIn 0.25s ease-in-out;
  font-family: "Poppins", sans-serif;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============ HEADER ============ */
h2 {
  margin-bottom: 0.3rem;
  color: var(--border-color-hover);
  font-size: 1.1rem;
  text-align: center;
}

.modal-desc {
  text-align: center;
  color: var(--text-color2);
  font-size: 0.85rem;
  margin-bottom: 1.2rem;
}

/* ============ USER DETAILS ============ */
.user-details p {
  font-size: 0.85rem;
  margin: 0.3rem 0;
  color: var(--text-color1);
}

.permissions {
  margin-top: 0.8rem;
}

.permissions ul {
  margin: 0.4rem 0 0;
  padding-left: 1.2rem;
}

.permissions li {
  font-size: 0.8rem;
  color: var(--text-color2);
  list-style: disc;
}

/* ============ BUTTONS ============ */
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 0.6rem;
  margin-top: 1.4rem;
  flex-wrap: wrap;
}

.btn {
  padding: 0.6rem 1.2rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.25s ease;
}

.btn.cancel {
  background: #ddd;
  color: #333;
}

.btn.cancel:hover {
  background: #bbb;
}

.btn.confirm {
  background: var(--button-color, #007bff);
  color: white;
}

.btn.confirm:hover {
  background: #0056b3;
  transform: translateY(-2px);
}

/* ============ RESPONSIVE ============ */
@media (max-width: 480px) {
  .modal-container {
    padding: 1rem;
    max-width: 95%;
  }

  h2 {
    font-size: 1rem;
  }

  .user-details p,
  .permissions li {
    font-size: 0.8rem;
  }

  .btn {
    flex: 1 1 45%;
    font-size: 0.8rem;
  }
}
</style>
